<template>
  <div class="warp" v-if="isLocalLogin">
    <div class="login">
      <el-form
        :model="ruleForm"
        status-icon
        ref="ruleForm"
        :rules="rules"
        label-width="70px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
      >
        <el-form-item label-width="0px" prop="username">
          <el-input
            type="text"
            v-model="ruleForm.username"
            placeholder="请输入帐号"
            prefix-icon="el-icon-user-solid"
          >
          </el-input>
        </el-form-item>
        <el-form-item label-width="0px" prop="password">
          <el-input
            type="password"
            v-model="ruleForm.password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
          ></el-input>
        </el-form-item>
        <el-form-item label-width="0px" prop="password">
          <el-col :span="16">
            <el-input
              type="text"
              v-model="ruleForm.code"
              placeholder="请输入验证码"
              prefix-icon="el-icon-lock"
            ></el-input
          ></el-col>
          <el-col :span="8">
            <div class="captcha"><img :src="codeUrl" @click="getCode" /></div>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm()">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 图形验证码 -->
    <!-- <Verify
      ref="verify"
      :captcha-type="'blockPuzzle'"
      :img-size="{ width: '400px', height: '200px' }"
      @success="submitForm"
    /> -->
  </div>
</template>
<script>
import { encryptString } from "@/utils/smcrypt";
// import Verify from "@/components/Verifition/Verify";
import { getCodeImg, login, loginToSso } from "../api/login";
import { setToken } from "../utils/auth";

export default {
  name: "loginView",
  components: {},
  data() {
    return {
      ruleForm: {
        username: "",
        password: "",
        uuid: "",
        code: null,
      },
      rules: {
        username: [{ required: true, message: "请输入帐号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      codeUrl: "",
      isLocalLogin: false,
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  created() {
    this.loginHandle();
  },

  mounted() {},
  methods: {
    getCode() {
      getCodeImg().then((res) => {
        this.codeUrl = "data:image/gif;base64," + res.img;
        this.ruleForm.uuid = res.uuid;
      });
    },

    loginHandle() {
      //获取地址栏中的 data 和 sign
      const data = this.$route.query.data;
      //console.log("vue data="+data)
      const sign = this.$route.query.sign;
      //console.log("vue sign="+sign)
      //调用登录的接口
      if (
        data == "" ||
        data == undefined ||
        data == null ||
        sign == "" ||
        sign == undefined ||
        sign == null
      ) {
        //请求中不带 data 和 sign，拦截为正常登录
        this.isLocalLogin = true;
        this.getCode();
      } else {
        this.loading = true; //开启过渡动画
        const loginInfo = {
          data: data,
          sign: sign,
        };
        //执行另一套登录操作
        //不是本系统的用户,去J平台登陆去
        this.LoginSso(loginInfo)
          .then(() => {
            this.$message.success("登录成功");
            this.$router.push({ path: this.redirect || "/" }).catch(() => {});
          })
          .catch((err) => {
            console.log("有异常信息", err);
            this.$message.error(err);
            this.loading = false;
          });
      }
    },
    LoginSso(userInfo) {
      const data = userInfo.data;
      const sign = userInfo.sign;
      const queryParams = {
        data: data,
        sign: sign,
      };
      return new Promise((resolve, reject) => {
        loginToSso(queryParams)
          .then((res) => {
            if (res.code === 200) {
              setToken(res.token);
              resolve();
            } else {
              reject(res.msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          const params = {
            username: this.ruleForm.username,
            password: encryptString(this.ruleForm.password),
            uuid: this.ruleForm.uuid,
            code: this.ruleForm.code,
          };
          login(params).then((v) => {
            if (v.code == 200) {
              setToken(v.token);
              this.$router.push("/");
            } else {
              this.getCode();
              this.$message.error(v.msg);
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.warp {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.login {
  box-sizing: border-box;
  width: 400px;
  height: 320px;
  margin-right: 140px;
  background-color: #fff;
  border-radius: 8px;
  padding: 40px;
}
.captcha {
  box-sizing: border-box;
  padding: 0 8px;
  img {
    max-width: 100%;
    height: 40px;
  }
}
</style>
